import { EndpointType, SignalFilterOption, SignalFilterOptionKey, SignalFilterOptionType } from '../interfaces/feed';

export const DefaultSignalFilterOptions: Array<SignalFilterOption> = [
  {
    label: 'newsFeedWidget.filterOption.allRelevant',
    type: SignalFilterOptionType.ACTION,
    key: SignalFilterOptionKey.ALL_RELEVANT,
    criterionUri: 'relevance',
    criterionValue: 'None',
    filterBy: {
      topRatingFilters: [
        {
          criterionUri: 'relevance',
          criterionValue: 'None'
        }
      ],
      userRatingFilters: [
        {
          criterionUri: 'isBadSignal',
          criterionValue: 'true'
        }
      ],
      minRatingCountForFiltration: 1
    },
    loadValueByEndpoint: false,
    showBlockedSignalAnimation: true
  },
  {
    label: 'newsFeedWidget.filterOption.positiveImpact',
    key: SignalFilterOptionKey.POSITIVE_IMPACT,
    type: SignalFilterOptionType.IMPACT,
    criterionUri: 'correlation',
    criterionValue: 'Positive',
    filterBy: {
      topRatingFilters: [
        {
          criterionUri: 'correlation',
          criterionValue: 'Positive'
        }
      ],
      userRatingFilters: [
        {
          criterionUri: 'isBadSignal',
          criterionValue: 'true'
        }
      ],
      minRatingCountForFiltration: 1
    },
    includeEvaluationBasis: true,
    loadValueByEndpoint: true,
    endpointType: EndpointType.TOP_RATED,
    featureFlag: 'insights.app.signal-ratings',
    showCount: true
  },
  {
    label: 'newsFeedWidget.filterOption.negativeImpact',
    key: SignalFilterOptionKey.NEGATIVE_IMPACT,
    type: SignalFilterOptionType.IMPACT,
    criterionUri: 'correlation',
    criterionValue: 'Negative',
    filterBy: {
      topRatingFilters: [
        {
          criterionUri: 'correlation',
          criterionValue: 'Negative'
        }
      ],
      userRatingFilters: [
        {
          criterionUri: 'isBadSignal',
          criterionValue: 'true'
        }
      ],
      minRatingCountForFiltration: 1
    },
    includeEvaluationBasis: true,
    loadValueByEndpoint: true,
    endpointType: EndpointType.TOP_RATED,
    featureFlag: 'insights.app.signal-ratings',
    showCount: true
  },
  {
    label: 'newsFeedWidget.filterOption.lessRelevant',
    type: SignalFilterOptionType.IMPACT,
    key: SignalFilterOptionKey.LESS_RELEVANT_SIGNAL,
    criterionUri: 'relevance',
    criterionValue: 'None',
    filterBy: {
      topRatingFilters: [
        {
          criterionUri: 'relevance',
          criterionValue: 'None'
        }
      ],
      userRatingFilters: [
        {
          criterionUri: 'isBadSignal',
          criterionValue: 'true'
        }
      ],
      minRatingCountForFiltration: 1
    },
    includeEvaluationBasis: true,
    loadValueByEndpoint: true,
    endpointType: EndpointType.USER_RATED,
    featureFlag: 'insights.app.signal-ratings',
    showCount: true
  },
  {
    label: 'newsFeedWidget.filterOption.badSignal',
    key: SignalFilterOptionKey.BAD_SIGNAL,
    type: SignalFilterOptionType.IMPACT,
    criterionUri: 'isBadSignal',
    criterionValue: 'true',
    filterBy: {
      userRatingFilters: [
        {
          criterionUri: 'isBadSignal',
          criterionValue: 'false'
        }
      ],
      minRatingCountForFiltration: 1
    },
    loadValueByEndpoint: true,
    clearSearchFilter: true,
    endpointType: EndpointType.USER_RATED,
    featureFlag: 'insights.app.block-signal',
    emptyResultsTips: ['newsFeedWidget.filterOption.badSignalEmptyTip'],
    showCount: false,
    showBlockedSignalAnimation: true
  }
];
